/* eslint-disable */
import Amplify, { Hub } from '@aws-amplify/core'
import Auth from '@aws-amplify/auth'

/* eslint-disable class-methods-use-this */
export default class AdminAuth {
  constructor() {
    const store = require('@/store')
    Amplify.configure({
      Auth: {
        region: process.env.VUE_APP_AWS_REGION,

        userPoolId: process.env.VUE_APP_COGNITO_USER_POOL_ID,

        userPoolWebClientId: process.env.VUE_APP_COGNITO_CLIENT_ID,

        authenticationFlowType: 'USER_PASSWORD_AUTH',
        redirectSignIn: process.env.VUE_APP_COGNITO_OKTA_REDIRECT_SIGNIN,
        redirectSignOut: process.env.VUE_APP_COGNITO_OKTA_REDIRECT_SIGNOUT,
        responseType: 'token',
        scope: [
          'email',
          'openid',
        ],
      },
      oauth: {
        domain: process.env.VUE_APP_COGNITO_SSO_DOMAIN,
        scope: [
          'email',
          'openid',
        ],
        redirectSignIn: process.env.VUE_APP_COGNITO_OKTA_REDIRECT_SIGNIN,
        redirectSignOut: process.env.VUE_APP_COGNITO_OKTA_REDIRECT_SIGNOUT,
        responseType: 'token',
      },
    })
    Hub.listen('auth', async ({ payload: { event, data } }) => {
      switch (event) {
        case 'signIn':
          const userData = await store.default.dispatch('auth/fetchUserData')
          store.default.commit('auth/SET_USER', userData)
          store.default._vm.$ability.update(userData.ability)
          localStorage.setItem('userData', JSON.stringify(userData))
          break
        default:
          break
      }
    })
  }

  async authenticateUser(username, password) {
    try {
      const user = await Auth.signIn(username, password)
      return { authenticated: true, user }
    } catch (error) {
      return { authenticated: false, error }
    }
  }

  async currentSession() {
    try {
      const session = await Auth.currentSession()
      return session
    } catch (err) {
      console.log(err)
    }
    return null
  }

  async refreshSession() {
    try {
      const user = await this.currentAuthenticatedUser()
      const currentSession = await this.currentSession()
      user.refreshSession(currentSession.refreshToken, () => {})
    } catch (err) {
      console.log(err)
    }
    return null
  }

  async currentAuthenticatedUser() {
    try {
      const user = await Auth.currentAuthenticatedUser()
      return user
    } catch (err) {
      console.log(err)
    }
    return null
  }

  async updatePassword(currentUser, newPassword) {
    try {
      const user = await Auth.completeNewPassword(currentUser, newPassword)
      return user
    } catch (err) {
      console.log(err)
    }
    return null
  }

  async signOut() {
    try {
      await Auth.signOut()
    } catch (err) {
      console.log(err)
    }
    return null
  }

  async federate(provider) {
    try {
      await Auth.federatedSignIn({ provider })
    } catch (e) {
      store._vm.$swal({
        title: 'Error!',
        text: 'Federated sign in with Okta not working.',
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    }
  }
}
